import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#0F172A', // Slate 900 - Premium dark blue/black
            light: '#334155', // Slate 700
            dark: '#020617', // Slate 950
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#3B82F6', // Blue 500 - Vibrant accent
            light: '#60A5FA',
            dark: '#2563EB',
            contrastText: '#ffffff',
        },
        background: {
            default: '#F8FAFC', // Slate 50 - Very light grey/white background
            paper: '#ffffff',
        },
        text: {
            primary: '#1E293B', // Slate 800
            secondary: '#64748B', // Slate 500
        },
        success: {
            main: '#10B981', // Emerald 500
        },
        error: {
            main: '#EF4444', // Red 500
        },
    },
    typography: {
        fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
        h1: {
            fontWeight: 700,
            letterSpacing: '-0.025em',
        },
        h4: {
            fontWeight: 600,
            letterSpacing: '-0.025em',
        },
        h6: {
            fontWeight: 600,
        },
        button: {
            fontWeight: 600,
            textTransform: 'none', // Modern look: no all-caps buttons
            borderRadius: 8,
        },
    },
    shape: {
        borderRadius: 12, // More rounded corners for a modern feel
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    padding: '10px 24px',
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
                    },
                },
                containedPrimary: {
                    background: 'linear-gradient(135deg, #0F172A 0%, #334155 100%)',
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)', // Subtle shadow
                    backgroundImage: 'none',
                },
                elevation1: {
                    boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
                }
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: '#E2E8F0', // Slate 200
                        },
                        '&:hover fieldset': {
                            borderColor: '#94A3B8', // Slate 400
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#3B82F6', // Blue 500
                        },
                    },
                },
            },
        },
        MuiStepper: {
            styleOverrides: {
                root: {
                    background: 'transparent',
                    padding: '24px 0',
                }
            }
        },
        MuiStepIcon: {
            styleOverrides: {
                root: {
                    color: '#CBD5E1', // Inactive color
                    '&.Mui-active': {
                        color: '#3B82F6',
                    },
                    '&.Mui-completed': {
                        color: '#10B981',
                    }
                }
            }
        }
    },
});

export default theme;
